import { Terminal } from 'lucide-react';

import type { TerminalMode, SSHConfig } from '../hooks/useTerminal';
import { useTerminal } from '../hooks/useTerminal';

interface TerminalPanelProps {
  mode: TerminalMode;
  sshConfig?: SSHConfig;
}

export function TerminalPanel({ mode, sshConfig }: TerminalPanelProps) {
  const { connected, termRef } = useTerminal(mode, sshConfig);

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '8px 16px',
          background: '#161b22',
          borderBottom: '1px solid #30363d',
          fontSize: 12,
        }}
      >
        <Terminal size={14} color={connected ? '#3fb950' : '#f85149'} />
        <span style={{ color: '#8b949e' }}>
          {mode === 'ssh'
            ? `SSH: ${sshConfig?.username}@${sshConfig?.host}:${sshConfig?.port}`
            : 'Local Terminal'}
        </span>
        <span
          style={{ marginLeft: 'auto', color: connected ? '#3fb950' : '#f85149', fontSize: 11 }}
        >
          {connected ? 'Connected' : 'Disconnected'}
        </span>
      </div>
      <div ref={termRef} style={{ flex: 1, padding: 4 }} />
    </div>
  );
}
